import { render, staticRenderFns } from "./demos.vue?vue&type=template&id=ffd61e9e"
import script from "./demos.vue?vue&type=script&lang=js"
export * from "./demos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports